var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { AppState } from "@/share/AppState";
import { UserRole } from "@/share/InternalUserStat";
import { MasterKeyRequest, MasterKeyRequestType } from "@/share/MasterKeyReq";
import { emailStringVerify } from "@@/Util";
import { action, makeObservable, observable } from "mobx";
import { NewConnectDialogState } from "../UIComponents/NewConnectDialog";
export var MasterKeyLoadStatus;
(function (MasterKeyLoadStatus) {
    MasterKeyLoadStatus[MasterKeyLoadStatus["Loading"] = 0] = "Loading";
    MasterKeyLoadStatus[MasterKeyLoadStatus["Unknown"] = 1] = "Unknown";
    MasterKeyLoadStatus[MasterKeyLoadStatus["Loaded"] = 2] = "Loaded";
})(MasterKeyLoadStatus || (MasterKeyLoadStatus = {}));
export class AdminStore {
    constructor() {
        this.loadStatus = MasterKeyLoadStatus.Unknown;
        this.masterkey = "";
        this.revealMasterKey = false;
        this.masterPasswordInput = "";
        this.storingMasterPassword = false;
        this.userPasswordInput = "";
        this.hasMasterKey = false;
        // @observable public hasmasterkey = false;
        this.checking = false;
        // @observable public activescreen: AdminScreens = "details";
        this.addinguser = false;
        this.loadingorgcontacts = false;
        this.loadinginternalusers = false;
        this.internalusers = new Map();
        this.orgcontacts = new Map();
        this.newusername = "";
        this.newuseremail = "";
        this.newuserrole = UserRole.User;
        this.addingcontact = false;
        this.editingcontact = false;
        this.neworgname = "";
        this.neworgemail = "";
        this.neworgnumber = -1;
        this.password = "";
        this.hint = "";
        this.cryptpassword = "";
        this.showpassword = false;
        this.edittingcontactid = "";
        this.edittinguser = false;
        this.editusername = "";
        this.statusupdate = false;
        this.fetchingdetail = false;
        this.edituserrole = UserRole.User;
        this.masterpassword = "";
        this.storingmpwd = false;
        this.workingOrgContacts = new Set();
        this.showbarcodescanner = false;
        this.adminsitelogin = false;
        this.companywatermark = "";
        this.updatewateramark = "";
        this.updateingwk = false;
        this.companyemail = "";
        this.updateemail = "";
        this.updateingemail = false;
        this.loadingquota = false;
        this.showimportcontacts = false;
        this.loadingexternalpassword = false;
        this.orgpassword = "";
        this.orghint = "";
        this.filtertextforexternalcontacts = "";
        this.isAdmin = false;
        this.adminStatusLoaded = false;
        this.myid = "";
        this.newconnectstate = new NewConnectDialogState();
        makeObservable(this);
        APPEvent.addSubscriberForMasterKeyResponse((req) => {
            this.setLoadStatus(MasterKeyLoadStatus.Loaded);
            if (req.error) {
                //APPEvent.publishApperror("Sorry, something went wrong. Please contact support for assistance");
            }
            else {
                if (req.masterkey) {
                    this.setMasterKey(req.masterkey);
                    this.setStoriengMasterPassword(false);
                    if (req.type === MasterKeyRequestType.Get) {
                        this.setRevealMasterKey(true);
                    }
                }
                this.setHasMasterKey(req.hasKey);
            }
        });
        APPEvent.addSubscriberForLoadInternalUsersRes((res) => {
            this.internalusers.clear();
            console.log(res);
            res.forEach((u) => this.internalusers.set(u.id, u));
            this.setLoadingInternalUser(false);
        });
        APPEvent.addSubscriberForLoadOrgContactsRes((res) => {
            this.orgcontacts.clear();
            res.forEach((oc) => this.orgcontacts.set(oc.id, oc));
            console.log("HEREE LOADEd");
            console.log(res);
            this.setLoadingOrgContacts(false);
        });
        APPEvent.addSubscriberForIsAdmin((admin) => {
            this.setIsAdmin(admin);
            this.adminStatusLoaded = true;
            if (admin) {
                this.checkHasMasterKey();
            }
        });
        APPEvent.addSubscriberForEditOrgContactsRes((res) => {
            if (res !== undefined) {
                this.updateOrgContact(res);
            }
            this.setEdittingContact(false);
            return res;
        });
        APPEvent.addSubscriberForAppState((st) => {
            if (st == AppState.LoggedIn) {
                this.loadMasterKey();
            }
            else {
                this.setMasterKey("");
            }
        });
    }
    setMyId(id) {
        this.myid = id;
    }
    setHasMasterKey(has) {
        this.hasMasterKey = has;
    }
    setIsAdmin(isadmin) {
        this.isAdmin = isadmin;
    }
    checkHasMasterKey() {
        if (this.loadStatus === MasterKeyLoadStatus.Loading) {
            return;
        }
        this.setLoadStatus(MasterKeyLoadStatus.Loading);
        const req = new MasterKeyRequest();
        req.type = MasterKeyRequestType.Has;
        Apphandler.sendMessage('masterkey', req);
    }
    loadMasterKey() {
        if (this.loadStatus === MasterKeyLoadStatus.Loading) {
            return;
        }
        this.setLoadStatus(MasterKeyLoadStatus.Loading);
        const req = new MasterKeyRequest();
        req.type = MasterKeyRequestType.GetM;
        req.password = this.userPasswordInput;
        Apphandler.sendMessage('masterkey', req);
        this.setMasterPasswordInput("");
        this.setUserPasswordInput("");
    }
    getMasterKey() {
        if (this.loadStatus === MasterKeyLoadStatus.Loading) {
            return;
        }
        this.setLoadStatus(MasterKeyLoadStatus.Loading);
        const req = new MasterKeyRequest();
        req.type = MasterKeyRequestType.Get;
        req.password = this.userPasswordInput;
        Apphandler.sendMessage('masterkey', req);
        this.setMasterPasswordInput("");
        this.setUserPasswordInput("");
    }
    getAndShowMasterKey() {
        if (!this.userPasswordInput) {
            return;
        }
        this.getMasterKey();
    }
    saveMasterPassword() {
        if (!this.masterPasswordInput || !this.userPasswordInput) {
            return;
        }
        if (this.loadStatus === MasterKeyLoadStatus.Loading) {
            return;
        }
        this.setLoadStatus(MasterKeyLoadStatus.Loading);
        const req = new MasterKeyRequest();
        req.type = MasterKeyRequestType.Add;
        req.masterkey = this.masterPasswordInput;
        req.password = this.userPasswordInput;
        Apphandler.sendMessage('masterkey', req);
        this.setMasterPasswordInput("");
        this.setUserPasswordInput("");
    }
    setStoriengMasterPassword(storing) {
        this.storingMasterPassword = storing;
    }
    setRevealMasterKey(rev) {
        this.revealMasterKey = rev;
    }
    setLoadStatus(status) {
        this.loadStatus = status;
    }
    setMasterKey(key) {
        this.masterkey = key;
    }
    setMasterPasswordInput(mp) {
        this.masterPasswordInput = mp;
    }
    setUserPasswordInput(mp) {
        this.userPasswordInput = mp;
    }
    reset() {
        this.setRevealMasterKey(false);
        this.setMasterKey("");
        this.setLoadStatus(MasterKeyLoadStatus.Unknown);
        this.setMasterPasswordInput("");
        this.setStoriengMasterPassword(false);
        this.setHasMasterKey(false);
        this.setMasterPasswordInput("");
        this.setUserPasswordInput("");
    }
    setLoadingInternalUser(loading) {
        this.loadinginternalusers = loading;
    }
    async getInternalUsers() {
        this.setLoadingInternalUser(true);
        Apphandler.sendMessage('loadinternalusers', "");
    }
    setLoadingOrgContacts(loading) {
        this.loadingorgcontacts = loading;
    }
    async loadOrgContacts() {
        this.setLoadingOrgContacts(true);
        Apphandler.sendMessage('loadorgcontacts', "");
    }
    getOrgContacts() {
        if (this.loadingorgcontacts) {
            return [];
        }
        console.log(this.orgcontacts);
        return Array.from(this.orgcontacts.values()).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }
    async checkAndUpgradeToAdmin() {
        if (this.loadStatus === MasterKeyLoadStatus.Loading && !this.adminStatusLoaded) {
            return undefined;
        }
        if (this.isAdmin && this.hasMasterKey) {
            return true;
        }
        return false;
    }
    setEdittinguser(edit) {
        this.edittinguser = edit;
    }
    setShowPassword(show) {
        this.showpassword = show;
    }
    setEditingContactId(id) {
        this.edittingcontactid = id;
    }
    setEdittingContact(edit) {
        this.editingcontact = edit;
    }
    setNewOrgname(name) {
        console.log(name);
        this.neworgname = name;
    }
    setNewOrgEmail(email) {
        this.neworgemail = email;
    }
    setNewOrgPassword(pwd) {
        this.password = pwd;
    }
    setNewOrgHint(hint) {
        this.hint = hint;
    }
    setDefaultOrgPassword(pwd) {
        this.orgpassword = pwd;
    }
    setDefaultOrgHint(hint) {
        this.orghint = hint;
    }
    setNewOrgNumber(number) {
        this.neworgnumber = number;
    }
    setNewusername(name) {
        this.newusername = name;
    }
    setNewUseremail(email) {
        this.newuseremail = email;
    }
    setNewuserRole(role) {
        this.newuserrole = role;
    }
    setChecking(check) {
        this.checking = check;
    }
    setAddingorgContact(add) {
        this.addingcontact = add;
    }
    setAddinguser(add) {
        this.addinguser = add;
    }
    setFetchingDetail(fetch) {
        this.fetchingdetail = fetch;
    }
    setCompanyWater(watermark) {
        this.companywatermark = watermark;
    }
    setUpdateWatermarl(mark) {
        this.updatewateramark = mark;
    }
    setCompanyemail(email) {
        this.companyemail = email;
    }
    setUpdateEmail(email) {
        this.updateemail = email;
    }
    updateOrgContact(cont) {
        this.orgcontacts.set(cont.id, cont);
    }
    editOrgContact() {
        if (emailStringVerify(this.neworgemail) || (this.neworgnumber && !isNaN(this.neworgnumber) && this.neworgnumber.toString().length >= 10)
            && this.edittingcontactid.trim() &&
            this.neworgname.trim() && this.password.length >= 4) {
            this.setEdittingContact(true);
            const req = {
                id: this.edittingcontactid,
                name: this.neworgname,
                email: this.neworgemail,
                number: this.neworgnumber,
                defaultpassword: this.password,
                defaultpasswordhint: this.hint
            };
            Apphandler.sendMessage('editorgcontact', req);
        }
    }
    async doAddOrgContact(name, email, pnumber, password, hint) {
        // const res = await AdminService.addOrgContact(name, email, pnumber,
        //     password, hint);
        // if (res !== 'internal' && res !== 'external' && res !== undefined) {
        //     this.updateOrgContact(res);
        //     const myself = this.internalusers.get(this.myid);
        //     if (myself != undefined && !myself.orgcontactvisible) {
        //         this.showOrgBookToUser(myself.id);
        //     }
        // }
        // return res;
    }
    async addOrgContact() {
        if (emailStringVerify(this.neworgemail) || (this.neworgnumber && !isNaN(this.neworgnumber) && this.neworgnumber.toString().length >= 10)
            &&
                this.neworgname.trim() && this.password.length >= 4 && this.myid) {
            this.setAddingorgContact(true);
            const res = this.doAddOrgContact(this.neworgname, this.neworgemail, this.neworgnumber + "", this.password, this.hint);
            this.setAddingorgContact(false);
            return res;
        }
        return "error";
    }
    async showOrgBookToUser(userid) {
        // this.workingOrgContacts.add(userid);
        // const user = this.internalusers.get(userid);
        // let ret = false;
        // if (await AdminService.showOrgBookToUser(userid)) {
        //     this.enableDisableOrgContactVisProp(userid, true);
        //     ret = true;
        // }
        // this.workingOrgContacts.delete(userid);
        // return ret;
    }
    enableDisableOrgContactVisProp(id, vis) {
        const user = this.internalusers.get(id);
        if (user !== undefined) {
            user.orgcontactvisible = vis;
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], AdminStore.prototype, "loadStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "masterkey", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "revealMasterKey", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "masterPasswordInput", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "storingMasterPassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "userPasswordInput", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminStore.prototype, "hasMasterKey", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "checking", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "addinguser", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "loadingorgcontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "loadinginternalusers", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminStore.prototype, "internalusers", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminStore.prototype, "orgcontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "newusername", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "newuseremail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "newuserrole", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "addingcontact", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "editingcontact", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "neworgname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "neworgemail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "neworgnumber", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "password", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "hint", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "cryptpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "showpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "edittingcontactid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "edittinguser", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "editusername", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "statusupdate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "fetchingdetail", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminStore.prototype, "edituserrole", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "masterpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "storingmpwd", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminStore.prototype, "workingOrgContacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "showbarcodescanner", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "adminsitelogin", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "companywatermark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "updatewateramark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "updateingwk", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "companyemail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "updateemail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "updateingemail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "loadingquota", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "quota", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "showimportcontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "loadingexternalpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "orgpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "orghint", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "filtertextforexternalcontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "isAdmin", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "adminStatusLoaded", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminStore.prototype, "myid", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setMyId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setHasMasterKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setIsAdmin", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setStoriengMasterPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setRevealMasterKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setLoadStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setMasterKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setMasterPasswordInput", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setUserPasswordInput", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setLoadingInternalUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setLoadingOrgContacts", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setEdittinguser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setShowPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setEditingContactId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setEdittingContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setNewOrgname", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setNewOrgEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setNewOrgPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setNewOrgHint", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setDefaultOrgPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setDefaultOrgHint", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setNewOrgNumber", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setNewusername", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setNewUseremail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setNewuserRole", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setChecking", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setAddingorgContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setAddinguser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setFetchingDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setCompanyWater", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setUpdateWatermarl", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setCompanyemail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "setUpdateEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "updateOrgContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], AdminStore.prototype, "showOrgBookToUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], AdminStore.prototype, "enableDisableOrgContactVisProp", null);
